// extracted by mini-css-extract-plugin
export default {"wrap":"Ft-z","fullWidth":"Gt-z","items":"Ht-z","featureCss":"It-z","disabled":"Jt-z","imgCss":"Kt-z"};